//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {declOfNum} from "@/utils/utils";

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    hasLink: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    pictureUrl (url) {
      return this.$absoluteImageUrl(url)
    },
    getDeclination(num, key){
      if (this.$i18n.locale === 'en') {
        return this.$tc(key, num > 1 ? 2 : 1)
      } else {
        return this.$tc(key, declOfNum(num));
      }
    },
  }
}
